export default "__VITE_ASSET__gLZD4d2W__"